import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { TextSizeProvider } from "@/context/TextSizeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import "@/lib/pwa";
import "@/lib/promo";
import "@/lib/track";
import LandingLP from "@/pages/LandingLP";
import AdminCampaigns from "@/pages/AdminCampaigns";
import AdminHome, { AdminGate } from "@/pages/AdminHome";
import AdminUsers from "@/pages/AdminUsers";
import AdminStripe from "@/pages/AdminStripe";
import AdminBroadcasts from "@/pages/AdminBroadcasts";
import AdminContent from "@/pages/AdminContent";
import { CookieBanner } from "@/components/CookieBanner";

import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import ManualSelect from "@/pages/ManualSelect";
import Report from "@/pages/Report";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import Paywall from "@/pages/Paywall";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Oggi from "@/pages/Oggi";
import Percorso from "@/pages/Percorso";
import DayView from "@/pages/DayView";
import Profilo from "@/pages/Profilo";
import Diario from "@/pages/Diario";
import Coach from "@/pages/Coach";
import AdminCoach from "@/pages/AdminCoach";
import AdminVersions from "@/pages/AdminVersions";
import Account from "@/pages/Account";
import Statistiche from "@/pages/Statistiche";
import Riepilogo from "@/pages/Riepilogo";
import Settings from "@/pages/Settings";
import InstallGuide from "@/pages/InstallGuide";
import Avvio from "@/pages/Avvio";

const Sub = ({ children }) => <ProtectedRoute requireSub>{children}</ProtectedRoute>;
const Auth_ = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <TextSizeProvider>
      <BrowserRouter>
        <div className="a2g-shell">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/lp" element={<LandingLP />} />
            <Route path="/admin" element={<AdminHome />} />
            <Route path="/admin/campagne" element={<AdminGate><AdminCampaigns /></AdminGate>} />
            <Route path="/admin/iscritti" element={<AdminGate><AdminUsers /></AdminGate>} />
            <Route path="/admin/stripe" element={<AdminGate><AdminStripe /></AdminGate>} />
            <Route path="/admin/comunicazioni" element={<AdminGate><AdminBroadcasts /></AdminGate>} />
            <Route path="/admin/contenuti" element={<AdminGate><AdminContent /></AdminGate>} />
            <Route path="/admin/versioni" element={<AdminGate><AdminVersions /></AdminGate>} />
            <Route path="/avvio" element={<Avvio />} />
            <Route path="/installa" element={<InstallGuide />} />
            <Route path="/test" element={<Quiz />} />
            <Route path="/scegli" element={<ManualSelect />} />
            <Route path="/report/:profileId" element={<Report />} />
            <Route path="/accedi" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/paywall" element={<Auth_><Paywall /></Auth_>} />
            <Route path="/payment/success" element={<Auth_><PaymentSuccess /></Auth_>} />
            <Route path="/oggi" element={<Sub><Oggi /></Sub>} />
            <Route path="/percorso" element={<Sub><Percorso /></Sub>} />
            <Route path="/percorso/giorno/:day" element={<Sub><DayView /></Sub>} />
            <Route path="/diario" element={<Sub><Diario /></Sub>} />
            <Route path="/coach" element={<Sub><Coach /></Sub>} />
            <Route path="/account" element={<Auth_><Account /></Auth_>} />
            <Route path="/admin/coach" element={<AdminGate><AdminCoach /></AdminGate>} />
            <Route path="/statistiche" element={<Sub><Statistiche /></Sub>} />
            <Route path="/riepilogo" element={<Sub><Riepilogo /></Sub>} />
            <Route path="/profilo" element={<Auth_><Profilo /></Auth_>} />
            <Route path="/impostazioni" element={<Auth_><Settings /></Auth_>} />
            <Route path="/account" element={<Navigate to="/profilo" replace />} />
          </Routes>
        </div>
        <CookieBanner />
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
      </TextSizeProvider>
    </AuthProvider>
  );
}

export default App;
